import { Error_Code } from '@/graphql/generated-schema-types';
import type { ApolloQueryResult, FetchResult } from '@apollo/client';

export interface SanitizedGraphQLError {
  message: string;
  path?: readonly (string | number)[];
  code?: unknown;
  debugMessage?: unknown;
}

export interface SanitizedGraphQLDebugInfo {
  hasData: boolean;
  hasErrors: boolean;
}

type GQLData = {
  gqlErrors: SanitizedGraphQLError[];
  debug: SanitizedGraphQLDebugInfo;
};

class SentryGraphQLError extends Error {
  public readonly data: GQLData;
  public readonly errorCode?: Error_Code | null;

  constructor(
    message: string,
    response: ApolloQueryResult<unknown> | FetchResult<unknown>,
    errorCode?: Error_Code | null
  ) {
    super(message);

    this.name = 'SentryGraphQLError';
    this.errorCode = errorCode;

    // oxlint-disable-next-line typescript/no-explicit-any
    let errors: readonly any[] = [];

    // MutationResult
    if ('error' in response && response.error) {
      errors = response.error.graphQLErrors ?? [];
    }

    // QueryResult
    if ('errors' in response && response.errors) {
      errors = response.errors;
    }

    const gqlErrors = (errors ?? []).map((e) => ({
      message: e.message.replace(
        /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi,
        '[email]'
      ),
      path: e.path,
      code: e.extensions?.code,
      debugMessage: e.extensions?.debugMessage,
    }));

    this.data = {
      gqlErrors,
      debug: {
        hasData: response.data !== null && response.data !== undefined,
        hasErrors: gqlErrors.length > 0,
      },
    };
  }
}

export default SentryGraphQLError;
